import jstz from 'jstz';

export default () => jstz.determine().name();
